<template>
    <div>
        <p class="mt-6 has-text-white" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading content...</p>
        <ui-card v-else>
            <h4 class="mb-5">{{session.title}}</h4>

            <div class="video-frame" v-if="this.session.intro_video_url && !preroll.played">
                <video-player
                    ref="videoPlayer"
                    :options="prerollPlayerOptions"


                    @statechanged="preRollOnStateChange($event)"
                />

                <div class="mt-3 mb-3"><b-button type="is-success" @click="preroll.played = true" expanded>Skip Introduction Video</b-button></div>
            </div>

            <div class="video-frame" v-else>
                <video-player
                    ref="videoPlayer"
                    :options="playerOptions"
                    v-if="session.media"

                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @statechanged="onPlayerStateChanged($event)"
                />
            </div>

            <div class="mt-5 mb-6">
                <div class="session-file" v-for="file in session.files">
                    <div class="columns">
                        <div class="column pt-5"><a :href="file.url" target="_blank"><i class="far fa-file mr-3"></i>{{ file.title }}</a></div>
                        <div class="column is-narrow">
                            <b-button tag="a" :href="file.url" target="_blank" class="is-outlined">
                                <i class="fad fa-share-from-square"></i>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-5 mb-4" v-html="session.information"></div>

            <div class="is-size-7 has-text-grey-dark" v-if="session.presenter"><i class="fad fa-fw fa-person-chalkboard mr-2"></i>{{session.presenter}}</div>

            <p class="mb-4 is-size-7 has-text-grey-dark" v-if="((session.media.duration/1000) < 3600)"><i class="fad fa-fw fa-clock mr-2"></i>00:{{(session.media.duration/1000) | moment('utc', 'mm:ss')}}</p>
            <p class="mb-4 is-size-7 has-text-grey-dark" v-else><i class="fad fa-fw fa-clock mr-2"></i>{{(session.media.duration/1000) | moment('utc', 'hh:mm:ss')}}</p>

            <div class="mt-4" v-if="session.recorded_time">
                <section v-if="session.recorded_minutes < session.max_log_minutes">
                    <b-progress class="session-progress mb-1 pb-0" size="is-small" type="is-primary" :value="session.recorded_minutes + Math.floor(this.time/60)" :max="session.max_log_minutes"></b-progress>
                    <div class="is-size-7 has-text-grey-dark">You have recorded {{(session.recorded_minutes + Math.floor(this.time/60))*60 | moment('utc', 'HH:mm')}} of the maximum of {{session.max_log_minutes * 60 | moment('utc', 'HH:mm')}} qualified time. Only full minutes are recorded to your <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check ml-1"></i> Record & Attendance Log</router-link>.</div>
                </section>
                <section v-else>
                    <div class="is-size-7 has-text-grey-dark"><i class="fad fa-fw fa-check has-text-success mr-2"></i>You have recorded the maximum amount of qualified time for this session. See details on your <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check ml-1"></i> Record & Attendance Log</router-link>.</div>
                </section>
            </div>
        </ui-card>
    </div>
</template>

<script>
    import {client as http} from "../../../http_client";
    import UiCard from "../../../components/UiCard";
    import async from "async";
    import {videoPlayer} from 'vue-video-player';
    import {v4 as uuidv4} from 'uuid';

    import 'video.js/dist/video-js.css';
    import {mapGetters} from "vuex";

    export default {
        components: {UiCard, videoPlayer},
        props: ['registrationId', 'sessionId'],
        data: function() {
            return {
                registration: {
                    conference: {
                        sessions: []
                    }
                },
                session: {
                    media: {}
                },
                loading: true,
                isRecording: false,
                time: 0,
                preroll: {
                    played: false
                }
            };
        },
        computed: {
            ...mapGetters({
                stateRegistration: 'registration' // TODO temp fix
            }),
            playerOptions: function() {
                return {
                    // videojs options
                    muted: false,
                    fluid: true,
                    language: 'en',
                    poster: this.session.media.poster,

                    autoplay: (this.session.intro_video_url),
                    sources: [{
                        type: this.session.media.mime_type,
                        src: this.session.media.url
                    }],
                };
            },
            prerollPlayerOptions: function() {
                return {
                    // videojs options
                    muted: false,
                    fluid: true,
                    language: 'en',
                    sources: [{
                        src: this.session.intro_video_url
                    }],
                };
            }
        },
        methods: {
            loadRegistration: function(force) {
                this.isRecording = false;

                async.series([
                    // get registration
                    cb => {
                        http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                            this.registration = response.data;
                            cb();
                        });
                    },
                    // get session
                    cb => {
                        http.get('app/conferences/' + this.registration.conference_id + '/sessions/' + this.sessionId, {force}).then(response => {
                            response.data.recorded_time = 0;
                            response.data.recorded_minutes = 0;
                            this.session = response.data;
                            cb();
                        });
                    },
                    // calc log
                    cb => {
                        // sum up all the log minutes and time for this session
                        this.registration.reg_record_log.forEach(log => {
                            if (log.session_id === this.session.id && log.minutes > 0) {
                                this.session.recorded_minutes += log.minutes;
                                this.session.recorded_time += log.time;
                            }
                        });

                        cb();
                    }
                ], err => {
                    if (err) {
                        console.log(err);
                    }
                    this.loading = false;

                    if (!this.stateRegistration.isLocked) this.startTimer();
                });
            },


            // listen event
            onPlayerPlay(player) {
                this.isRecording = true;

                if(!this.uuid) {
                    this.uuid = uuidv4();
                    this.sendPing('init');
                } else {
                    this.sendPing('play');
                }
            },
            onPlayerPause(player) {
                this.isRecording = false;
                this.sendPing('pause');
            },

            onPlayerEnded(player) {
                this.isRecording = false;
                this.sendPing('end', data => {
                    // this.uuid = uuidv4(); // if they reached the end we want to start a new record
                    // this.time = 0;
                });
            },
            onPlayerStateChanged(playerCurrentState) {
                // console.log('player current update state', playerCurrentState)
            },

            preRollOnStateChange(playerCurrentState) {
                // console.log('preroll player current update state', playerCurrentState)
                if (playerCurrentState.ended) {
                    this.preroll.played = true;
                }
            },

            startTimer: function() {
                this.timer = setInterval(() => {
                    if (this.isRecording) {
                        this.time++;
                        this.session.recorded_time++;
                        if (this.time % 60 === 0) this.sendPing('ping');
                    }
                }, 1000);
            },

            sendPing: function(event, callback) {
                let payload = {
                    event,
                    title: this.session.title,
                    record_id: this.uuid,
                    time: this.time,
                    session_id: this.session.id,
                    conference_id: this.registration.conference_id,
                    registration_id: this.registration.id,
                };

                if (!this.stateRegistration.isLocked) {
                    http.post('/app/registrations/ping', payload, {force: true}).then(response => {
                        if (callback) callback(response.data);
                    }).catch(err => {
                        // TODO handle conflict error
                    });
                }
            },
        },
        mounted() {
            this.loadRegistration();
        },
        beforeDestroy() {
            clearInterval(this.timer);
            this.sendPing('unload');
        }
    };
</script>

<style scoped lang="scss">
    .video-frame {
        border-radius: 5px;
        margin: 0;
        border: 1px solid #e7e7e7;
        padding: 10px;
    }

    .session-file {
        border: 1px solid #e7e7e7;
        background: white;
        padding: 5px 16px 6px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
</style>

<style lang="scss">
    .session-progress .progress {
        height: 0.25rem !important;
    }
</style>
